export const inArray = (array, ids) => ids.every(_id => array.includes(_id));


